export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40f1dec96391471ba89a2c973ec83a498579a65409&name=revalidateCommunity!'